import { type CountryCode } from '@wix/form-multiline-address';
import React, {
  createContext,
  type ReactNode,
  useContext,
  useMemo,
} from 'react';

type CountryCodeValue = {
  countryCode?: CountryCode;
};

const CountryCodeContext = createContext<CountryCodeValue | undefined>(
  undefined,
);

export interface CountryCodeProviderProps {
  children: ReactNode;
  countryCode?: CountryCode;
}

export const CountryCodeProvider = ({
  children,
  countryCode,
}: CountryCodeProviderProps) => {
  const value = useMemo(() => ({ countryCode }), [countryCode]);
  return (
    <CountryCodeContext.Provider value={value}>
      {children}
    </CountryCodeContext.Provider>
  );
};

export function useCountryCode() {
  const context = useContext(CountryCodeContext);
  return context?.countryCode;
}
